import { request } from './client.js';

export const dashboardApi = {
  get: () => request('/api/dashboard'),
};
